var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n  h1,h2,h3,h4,h5,h6,p, li, label {\n    background-color: ', ';\n  }\n  &:after {\n    position: absolute;\n    width: auto;\n    height: auto;\n    z-index: 9999;\n    content: \'\';\n    display: block;\n    pointer-events: none;\n    top:  ', ';\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: linear-gradient(rgba(255, 0, 0, 0.35), rgba(255, 0, 0, 0.35) 1px, transparent 1px);\n    background-size: 1px 25px;\n    opacity: ', ';\n  }\n'], ['\n  position: relative;\n  h1,h2,h3,h4,h5,h6,p, li, label {\n    background-color: ', ';\n  }\n  &:after {\n    position: absolute;\n    width: auto;\n    height: auto;\n    z-index: 9999;\n    content: \'\';\n    display: block;\n    pointer-events: none;\n    top:  ', ';\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: linear-gradient(rgba(255, 0, 0, 0.35), rgba(255, 0, 0, 0.35) 1px, transparent 1px);\n    background-size: 1px 25px;\n    opacity: ', ';\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component } from 'react';
import styled from 'styled-components';
import Lines from './8.svg';
var GridLines = styled.div(_templateObject, function (props) {
  return props.enabled ? "rgba(0,0,255,0.1)" : "rgba(255,0,0,0.0)";
}, function (props) {
  return props.offset ? props.offset + 'px' : '0px';
}, function (props) {
  return props.enabled ? '1' : '0';
});

var Grid = function Grid(props) {
  return React.createElement(GridLines, props, props.children);
};

export default Grid;